import { useIsSmallerThanSm } from "@shared/hooks/useIsSmallerThan";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";

export interface BadgeProps {
  icon: React.ReactNode;
  text: React.ReactNode;
  isVisible: boolean;
  "data-testid": string;
}

export interface ChildBadgeProps {
  isVisible?: boolean;
}

export const Badge = ({
  icon,
  text,
  isVisible,
  "data-testid": dataTestId,
}: BadgeProps) => {
  const isSmallerThanSm = useIsSmallerThanSm();

  if (!isVisible) return null;

  const padding = isSmallerThanSm ? "5px 0px" : "8px 0px";
  const alignItems = isSmallerThanSm ? "center" : "flex-start";

  return (
    <Flex data-testid={dataTestId} padding={padding} alignItems={alignItems}>
      <Flex alignItems="center">
        {icon} <Text marginLeft="2xs">{text}</Text>
      </Flex>
    </Flex>
  );
};
